import Layout from '@/layout'
import EmptyLayout from '@/layout/EmptyLayout'
import FullLayout from '@/layout/FullLayout'

const businessRouter = {
  path: '/',
  component: Layout,
  name: 'business',
  meta: { title: '业务系统' },
  redirect: '/login',
  children: [{
    path: '/index',
    name: 'index',
    component: () => import('@/views/Home'),
    meta: { title: '首页' }
  },
  {
    path: 'realTime',
    name: 'realTime',
    meta: { title: '实时监测' },
    redirect: '/realTime/overview',
    component: FullLayout,
    children: [{
      path: '/realTime/overview',
      name: 'overview',
      component: () => import('@/views/business/realTime/Overview'),
      meta: { title: '用能概况', activeMenu: '/realTime' },
      hidden: true
    },
    {
      path: '/realTime/jxt',
      name: 'jxt',
      component: () => import('@/views/business/realTime/Yicijiexiantu'),
      meta: { title: '一次接线图', activeMenu: '/realTime' },
      hidden: true
    },
    {
      path: '/realTime/framework',
      name: 'framework',
      component: () => import('@/views/business/realTime/PowerStruct'),
      meta: { title: '用能架构图', activeMenu: '/realTime' },
      hidden: true
    },
    {
      path: '/realTime/sankey',
      name: 'sankey',
      component: () => import('@/views/business/realTime/Sankey'),
      meta: { title: '能流图', activeMenu: '/realTime' },
      hidden: true
    },
    {
      path: '/realTime/environment',
      name: 'environment',
      component: () => import('@/views/business/realTime/Environment'),
      meta: { title: '环境监测', activeMenu: '/realTime' },
      hidden: true
    },
    {
      path: '/realTime/jk',
      name: 'jk',
      component: () => import('@/views/business/video/index'),
      meta: { title: '视频监控', activeMenu: '/realTime' },
      hidden: true
    },
    {
      path: '/realTime/replay',
      name: 'replay',
      component: () => import('@/views/business/video/video-replay'),
      meta: { title: '监控回放', activeMenu: '/realTime' },
      hidden: true
    },
    {
      path: '/realTime/equipmentStatus',
      name: 'equipmentStatus',
      component: () => import('@/views/business/operationsManagement/equipmentStatus.vue'),
      meta: { title: '设备工况', activeMenu: '/realTime' },
      hidden: true
    }]
  },

  {
    path: 'query',
    name: 'query',
    redirect: '/efficiencyManagement/query/query',
    component: FullLayout,
    meta: { title: '综合查询' },
    children: [
      {
        path: '/efficiencyManagement/query/query',
        name: 'zhcx',
        component: () => import('@/views/business/query/Query'),
        meta: { title: '综合查询', activeMenu: '/query' },
        hidden: true
      },
      {
        path: '/efficiencyManagement/query/yncx',
        name: 'yncx',
        component: () => import('@/views/business/query/EnergyQuery'),
        meta: { title: '用能查询', activeMenu: '/query' },
        hidden: true
      },
      {
        path: '/efficiencyManagement/query/compare',
        name: 'compare',
        component: () => import('@/views/business/query/Compare'),
        meta: { title: '对比分析', activeMenu: '/query' },
        hidden: true
      },
      {
        path: '/efficiencyManagement/query/peakValley',
        name: 'peakValley',
        component: () => import('@/views/business/query/PeakValley'),
        meta: { title: '峰谷分析', activeMenu: '/query' },
        hidden: true
      }
    ]
  },
  {
    path: 'count',
    name: 'count',
    redirect: '/efficiencyManagement/count/countAnalysis',
    component: FullLayout,
    meta: { title: '统计分析' },
    children: [
      {
        path: '/efficiencyManagement/count/countAnalysis',
        name: 'statisticalAnalysis',
        component: () => import('@/views/business/query/StatisticalAnalysis'),
        meta: { title: '统计分析', activeMenu: '/count' },
        hidden: true
      }
    ]
  },
  {
    path: 'operationsManagement',
    name: 'operationsManagement',
    meta: { title: '健康度' },
    redirect: '/operationsManagement/healthDegree',
    component: FullLayout,
    children: [
      {
        path: '/operationsManagement/healthDegree',
        name: 'healthDegree',
        component: () => import('@/views/business/deviceManage/healthDegree/healthDegreePDS'),
        meta: { title: '健康度', activeMenu: '/operationsManagement' },
        hidden: true
      }
    ]
  },
  {
    path: 'warning',
    name: 'allWarning',
    meta: { title: '告警信息' },
    redirect: '/warning/allWarning',
    component: FullLayout,
    children: [
      {
        path: 'allWarning',
        name: 'warning',
        component: () => import('@/views/business/warning/allWarning'),
        meta: { title: '告警信息', activeMenu: '/warning' },
        hidden: true
      },
      {
        path: 'warningSetting',
        name: 'warningSetting',
        component: () => import('@/views/business/warning/warningSetting'),
        meta: { title: '告警配置', activeMenu: '/warning' },
        hidden: true
      },
      {
        path: 'warningRuleSetting',
        name: 'warningRuleSetting',
        component: () => import('@/views/business/warning/warningRuleSetting'),
        meta: { title: '规则配置', activeMenu: '/warning' },
        hidden: true
      }
    ]
  },
  {
    path: 'deviceManage',
    name: 'deviceManage',
    meta: { title: '设备管理' },
    redirect: '/deviceManage/realStatus',
    component: FullLayout,
    children: [
      {
        path: '/deviceManage/realStatus',
        name: 'realStatus',
        component: () => import('@/views/business/deviceManage/realStatus/index.vue'),
        meta: { title: '实时状态', activeMenu: '/deviceManage' },
        hidden: true
      }
    ]
  },
  {
    path: 'ReportManage',
    name: 'ReportManage',
    meta: { title: '报表管理' },
    redirect: '/ReportManage/customReport',
    component: FullLayout,
    children: [
      {
        path: '/ReportManage/customReport',
        name: 'customReport',
        component: () => import('@/views/business/report/customReport'),
        meta: { title: '自定义报表', activeMenu: '/ReportManage' },
        hidden: true
      },
      {
        path: '/ReportManage/report',
        name: 'report',
        component: () => import('@/views/business/report/report'),
        meta: { title: '报表管理', activeMenu: '/ReportManage' },
        hidden: true
      },
      {
        path: '/ReportManage/setting',
        name: 'reportSetting',
        component: () => import('@/views/business/report/reportSetting'),
        meta: { title: '报表配置', activeMenu: '/ReportManage' },
        hidden: true
      },
      {
        path: '/ReportManage/reportV2',
        name: 'reportV2',
        component: () => import('@/views/business/report/ZiDingYiBaoBiaoChaXun'),
        meta: { title: '报表V2.0', activeMenu: '/ReportManage' },
        hidden: true
      },
      {
        path: '/ReportManage/reportSettingV2',
        name: 'reportSettingV2',
        component: () => import('@/views/business/report/ZiDingYiBaoBiao'),
        meta: { title: '报表配置V2.0', activeMenu: '/ReportManage' },
        hidden: true
      }
    ]
  }
  ]
}
export default businessRouter

